export type DeviceAuthPolicyInput = {
    hasStoredPasskey: boolean
    verified: boolean
    attempted: boolean
    lastActivityTs: number | null
    now?: number
    inactivityMs: number
}

export type DeviceAuthPolicyDecision = {
    skipAuth: boolean
    clearExpiredSession: boolean
}

export function isInactivityExpired(lastActivityTs: number | null, inactivityMs: number, now = Date.now()) {
    return !!lastActivityTs && now - lastActivityTs >= inactivityMs
}

export function evaluateDeviceAuthPolicy(input: DeviceAuthPolicyInput): DeviceAuthPolicyDecision {
    const { hasStoredPasskey, verified, attempted, lastActivityTs, inactivityMs, now = Date.now() } = input

    if (verified) {
        if (hasStoredPasskey) {
            if (isInactivityExpired(lastActivityTs, inactivityMs, now)) {
                return { skipAuth: false, clearExpiredSession: true }
            }
            return { skipAuth: true, clearExpiredSession: false }
        }
        if (isInactivityExpired(lastActivityTs, inactivityMs, now)) {
            return { skipAuth: false, clearExpiredSession: true }
        }
        return { skipAuth: false, clearExpiredSession: false }
    }

    if (hasStoredPasskey && attempted) {
        return { skipAuth: true, clearExpiredSession: false }
    }

    return { skipAuth: false, clearExpiredSession: false }
}
